<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>

        <b-button-group class="mr-3">

          <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                    :to="currentPage.name + '-form-new'" primary/>


          <t-dropdown v-if="userAuth.relationPages.length > 0"
                      variant="outline-primary" icon-settings
                      :items-relation-pages="userAuth.relationPages"/>

        </b-button-group>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form"/>
      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="compoundCodeLabel"
               primary-key-column="compoundNumber">


        <template #item(colorDescription)="{item}">

          <div class="d-flex align-items-start justify-content-start">

            <div class="mb-2 mr-2 badge badge-dot badge-dot-xl" :style="{'background-color': item.color}"></div>
            <div>{{ item.colorDescription }}</div>

          </div>


        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Compound',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
